var faqAccordion = function() {
  var checker = exists('.faq');

  if (checker) {
    var faqItems = document.querySelectorAll('.faq-item'),
      activeClass = 'faq-item--active',
      isActive = false;

    var toggle = function() {
      if (this == isActive) {
        isActive.classList.remove(activeClass);
        $(isActive).find('.faq-answer').slideUp();
        isActive = false;
      } else {
        if (isActive) {
          isActive.classList.remove(activeClass);
          $(isActive).find('.faq-answer').slideUp();
        }
        isActive = this;
        isActive.classList.add(activeClass);
        $(isActive).find('.faq-answer').slideDown();
      }
    }

    for (var i = 0; i < faqItems.length; i++) {
      var item = faqItems[i];
      item.addEventListener('click', toggle);
    }
  }
}

window.addEventListener('load', () => {
  faqAccordion();
});
